import { FC } from 'react';
import { useAppSelector } from '../../../hooks/store.hooks';
import { useNavigate } from 'react-router-dom';
import EditProfileProvider from '../memory/memr';
import InitMiddlewareProductEdit from '../middlewares/InitMiddleware';

const EditProfileInstance: FC<{}> = () => {
  const { userToken } = useAppSelector((state: any) => state.rootReducer.auth);

  return (
    <EditProfileProvider>
      <InitMiddlewareProductEdit />
    </EditProfileProvider>
  );
};

export default EditProfileInstance;
